import type { Room } from "@/types/Room";

export const DEFAULT_ROOM_CAPACITY = 2;

export const getRoomCapacity = (room: Pick<Room, "capacity"> | null | undefined): number =>
  room?.capacity ?? DEFAULT_ROOM_CAPACITY;

export const formatRoomCapacity = (room: Pick<Room, "capacity"> | null | undefined): string => {
  const capacity = getRoomCapacity(room);
  return `${capacity} ${capacity === 1 ? "person" : "people"}`;
};
